import React from "react";
import { connect } from "react-redux";

// import NavItems from "../Navbar/NavItems/NavItems";
import Button from "../../components/Button/Button";
// import ContentBlock from "../../sections/ContentBlock/ContentBlock";

import "./Footer.css";

const footer = (props) => {
  return (
    <div className="Footer">
      <div className="footerLeft">
        <img
          className="footerDCLogo"
          src="https://districttrack.s3.us-east-2.amazonaws.com/v2/logos/DC-logo-white.png"
          alt="DC logo"
        />
        <div className="upper">
          District
          <br />
          Track
          <br />
          Club
          <br />
        </div>
        {/* <div>
          <NavItems />
        </div> */}
      </div>
      <div className="container footer-main">
        <div className="social">
          <a href="mailto: districttrackclub@gmail.com" className="socialIcon">
            <img
              alt="Email"
              className="reg email"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/email-dark.png"
            />
            <img
              alt="Email"
              className="invert email"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/email-light.png"
            />
          </a>
          <a href="https://twitter.com/DistrictTC" className="socialIcon">
            <img
              alt="Twitter"
              className="reg"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/twitter-dark.png"
            />
            <img
              alt="Twitter"
              className="invert"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/twitter-light.png"
            />
          </a>
          <a
            href="https://www.instagram.com/districttrackclub"
            className="socialIcon"
          >
            <img
              alt="Instagram"
              className="reg"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/instagram-dark.png"
            />
            <img
              alt="Instagram"
              className="invert"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/instagram-light.png"
            />
          </a>
          <a
            href="https://www.youtube.com/channel/UC3qnkXuW9Pf_PJAy4J0FDVg"
            className="socialIcon youtube"
          >
            <img
              alt="Youtube"
              className="reg"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/youtube-dark.png"
            />
            <img
              alt="Instagram"
              className="invert"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/icons/youtube-light.png"
            />
          </a>
        </div>
        <div className="powered-by upper">
          <p>We are Proudly Sponsored by</p>
          <img
            src="https://districttrack.s3.us-east-2.amazonaws.com/v2/logos/UA-white.png"
            alt="Under Armour"
          />
        </div>
        <div className="copyright">
          COPYRIGHT &#169; 2021. ALL RIGHTS RESERVED.
        </div>
      </div>
      <div className="footerRight">
        {props.userId ? null : (
          <React.Fragment>
            <h4 className="upper">Join the Virtual Performance Center</h4>
            <Button buttonType="Primary" size="sm" to="/auth">
              Log In
            </Button>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.userId,
  };
};

export default connect(mapStateToProps)(footer);
